import type { Types as SduiTypes } from '../types';
import type { CoreTypes } from '../../core';
import _classes from './classes';
import _courses from './courses';
import _lessons from './lessons';
import _rooms from './rooms';
import _schoolYears from './school-years';
import _substitutionPlans from './substitution-plans';
import _teachers from './teachers';
import type { InternalIdKey } from '../../core/types/common';

export namespace OutTypes {
  export type division  = Pick<CoreTypes.Serialized.Division, 'start' | 'end'>;
  export type group     = Omit<CoreTypes.Serialized.Group,      InternalIdKey>;
  export type person    = Omit<CoreTypes.Serialized.Person,     InternalIdKey>;
  export type teacher   = Omit<CoreTypes.Serialized.Teacher,    InternalIdKey | 'person'> & { person: OutTypes.person };
  export type location  = Omit<CoreTypes.Serialized.Location,   InternalIdKey>;
  export type course    = Omit<CoreTypes.Serialized.Course,     InternalIdKey>;
  export type event     = Omit<CoreTypes.Serialized.Event,      InternalIdKey>;
  export type exception = Omit<CoreTypes.Serialized.Exception,  InternalIdKey>;
}

type Out = {
  divisions:  OutTypes.division;
  groups:     OutTypes.group[];
  teachers:   OutTypes.teacher[];
  locations:  OutTypes.location[];
  courses:    OutTypes.course[];
  events:     OutTypes.event[];
  exceptions: OutTypes.exception[];
};

export default (schedule: SduiTypes.schedule): Out => {
  return {
    divisions:  _schoolYears(schedule.schoolYear),
    groups:     schedule.classes ?.map(_classes)  ?? [],
    teachers:   schedule.teachers?.map(_teachers) ?? [],
    locations:  schedule.rooms   ?.map(_rooms)    ?? [],
    courses:    schedule.courses ?.map(_courses)  ?? [],
    events:     schedule.lessons ?.map(_lessons)  ?? [],
    exceptions: _substitutionPlans(schedule.substitution_plan),
    // settings:             schedule.hours?.map(_hours)[0] ?? {},
    // holidays:             schedule.holidays?.map(_holidays),
    // subjects:             schedule.subjects?.map(_subjects),
  };
};